import { css } from '@emotion/css';

export const baseInputStyles = css`
  font: inherit;
`;
